import React, { useEffect, useState } from 'react';
import {
  getProducts,
  createProduct,
  updateProduct,
  deleteProduct,
  markProductInactive,
  createBulkProducts,
} from '../service';
// import { PRODUCTS } from '../constants';
import { handleAPIError } from '../../../utils/apiUtils';

const useProductState = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchProducts = async () => {
    try {
      setLoading(true);
      const data = await getProducts();
      setProducts(data);
    } catch (error) {
      console.error('Failed to fetch products', error);
      // setProducts(PRODUCTS);
    } finally {
      setLoading(false);
    }
  };

  const sortAndSetProducts = (productsList) => {
    productsList.sort((a, b) => {
      if (a.is_active !== b.is_active) {
        return b.is_active - a.is_active;
      }

      if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
      if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
      return 0;
    });
    setProducts(productsList);
  }

  const addOrUpdate = async (product) => {
    let response = {
      success: false,
      code: null,
      message: null,
    };
    try {
      if (product.id) {
        const updated = await updateProduct(product.id, product);
        const updatedProducts = products.map(c => (c.id === updated.id ? updated : c));
        sortAndSetProducts(updatedProducts);
        response.success = true;
      } else {
        const created = await createProduct(product);
        const updatedProducts = [...products, created];
        sortAndSetProducts(updatedProducts);
        response.success = true;
      }
      fetchProducts();
    } catch (error) {
      response = handleAPIError(error);
      console.error('Failed to add or update product', error);
    }
    return response;
  };

  const remove = async (id) => {
    try {
      await deleteProduct(id);
      const updatedProducts = products.filter(c => c.id !== id);
      sortAndSetProducts(updatedProducts);
    } catch (error) {
      console.error('Failed to delete product', error);
    }
  };

  const markInactive = async (id, date) => {
    try {
      await markProductInactive(id, date);
      const updatedProducts = products.map(c => 
        c.id === id ? { ...c, is_active: !c.is_active, last_deactivation_date: date } : c
      );
      sortAndSetProducts(updatedProducts);
    } catch (error) {
      console.error('Failed to mark inactive the product', error);
    }
  }

  const importProducts = async (products) => {
    let response = {
      success: false,
      code: null,
      message: null,
    };
    try {
      const created = await createBulkProducts(products);
      if (created) {
        response.success = true;
      }
    } catch (error) {
      response = handleAPIError(error);
      console.error('Failed to add or update product', error);
    } finally {
      return response;
    }
  }

  useEffect(() => {
    fetchProducts();
  }, []);

  return { products, loading, addOrUpdate, remove, markInactive, importProducts };
};

export default useProductState;
